import { render, staticRenderFns } from "./AdvancedOTPCertn.vue?vue&type=template&id=a152d650"
import script from "./AdvancedOTPCertn.vue?vue&type=script&lang=js"
export * from "./AdvancedOTPCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a152d650')) {
      api.createRecord('a152d650', component.options)
    } else {
      api.reload('a152d650', component.options)
    }
    module.hot.accept("./AdvancedOTPCertn.vue?vue&type=template&id=a152d650", function () {
      api.rerender('a152d650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/AdvancedOTPCertn.vue"
export default component.exports